/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { ActionStatusEnumType } from "./ActionStatusEnum"
import { RootStoreType } from "./index"


/**
 * RouteActionDtoBase
 * auto generated base class for the model RouteActionDtoModel.
 */
export const RouteActionDtoModelBase = ModelBase
  .named('RouteActionDto')
  .props({
    __typename: types.optional(types.literal("RouteActionDto"), "RouteActionDto"),
    actionUuid: types.identifier,
    name: types.union(types.undefined, types.string),
    projectId: types.union(types.undefined, types.integer),
    userUuid: types.union(types.undefined, types.string),
    input: types.union(types.undefined, types.null, types.string),
    undo: types.union(types.undefined, types.null, types.boolean),
    redo: types.union(types.undefined, types.null, types.boolean),
    status: types.union(types.undefined, ActionStatusEnumType),
    failReason: types.union(types.undefined, types.null, types.string),
    receivedAt: types.union(types.undefined, types.null, types.string),
    createdAt: types.union(types.undefined, types.null, types.string),
    routeUuid: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RouteActionDtoModelSelector extends QueryBuilder {
  get actionUuid() { return this.__attr(`actionUuid`) }
  get name() { return this.__attr(`name`) }
  get projectId() { return this.__attr(`projectId`) }
  get userUuid() { return this.__attr(`userUuid`) }
  get input() { return this.__attr(`input`) }
  get undo() { return this.__attr(`undo`) }
  get redo() { return this.__attr(`redo`) }
  get status() { return this.__attr(`status`) }
  get failReason() { return this.__attr(`failReason`) }
  get receivedAt() { return this.__attr(`receivedAt`) }
  get createdAt() { return this.__attr(`createdAt`) }
  get routeUuid() { return this.__attr(`routeUuid`) }
}
export function selectFromRouteActionDto() {
  return new RouteActionDtoModelSelector()
}

export const routeActionDtoModelPrimitives = selectFromRouteActionDto().actionUuid.name.projectId.userUuid.input.undo.redo.status.failReason.receivedAt.createdAt.routeUuid
